// eslint-disable-next-line import/no-unresolved
import colors from 'vuetify/util/colors'
// eslint-disable-next-line import/no-unresolved
import * as components from 'vuetify/components'
// eslint-disable-next-line import/no-unresolved
import * as directives from 'vuetify/directives'
import { IconSet } from 'vuetify'
import { h } from 'vue'

const defaultColors = {
  primary: '#432CA0',
  error: '#FF0000',
  'sm-bronze': '#A69711',
  purple: '#765FD3',
  'light-green-lighten1': colors.lightGreen.lighten1,
  'light-green-lighten2': colors.lightGreen.lighten2,
  'light-green-lighten3': colors.lightGreen.lighten3,
  'light-green-lighten4': colors.lightGreen.lighten4,
  'light-green-lighten5': colors.lightGreen.lighten5,
  'light-green-lighten6': '#F1EFFB',
  'light-green-base': colors.lightGreen.base,
  'light-green-darken1': colors.lightGreen.darken1,
  'light-green-darken2': colors.lightGreen.darken2,
  'light-green-darken3': colors.lightGreen.darken3,
  'light-green-darken4': colors.lightGreen.darken4,
  'indigo-lighten5': colors.indigo.lighten5,
  'indigo-lighten4': colors.indigo.lighten4,
  'indigo-lighten3': colors.indigo.lighten3,
  'indigo-lighten2': colors.indigo.lighten2,
  'indigo-lighten1': colors.indigo.lighten1,
  'indigo-base': colors.indigo.base,
  'indigo-darken1': colors.indigo.darken1,
  'indigo-darken2': colors.indigo.darken2,
  'indigo-darken3': '#432CA0',
  'indigo-darken4': colors.indigo.darken4,
  'cyan-lighten5': colors.cyan.lighten5,
  'cyan-lighten4': colors.cyan.lighten4,
  'cyan-lighten3': colors.cyan.lighten3,
  'cyan-lighten2': colors.cyan.lighten2,
  'cyan-lighten1': colors.cyan.lighten1,
  'cyan-base': colors.cyan.base,
  'cyan-darken1': '#2db4af',
  'cyan-darken2': colors.cyan.darken2,
  'cyan-darken3': colors.cyan.darken3,
  'cyan-darken4': colors.cyan.darken4,
  'pink-lighten5': colors.pink.lighten5,
  'pink-lighten4': colors.pink.lighten4,
  'pink-lighten3': colors.pink.lighten3,
  'pink-lighten2': colors.pink.lighten2,
  'pink-lighten1': colors.pink.lighten1,
  'pink-base': colors.pink.base,
  'pink-darken1': colors.pink.darken1,
  'pink-darken2': colors.pink.darken2,
  'pink-darken3': '#9F1919',
  'pink-darken4': colors.pink.darken4,
  'grey-lighten-1': colors.grey.lighten1,
  'grey-lighten-2': colors.grey.lighten2,
  'grey-lighten-3': colors.grey.lighten3,
  'grey-lighten-4': colors.grey.lighten4,
  'grey-lighten-5': colors.grey.lighten5,
  'grey-darken-1': colors.grey.darken1,
  'grey-darken-2': colors.grey.darken2,
  'grey-darken-3': colors.grey.darken3,
  'grey-darken-4': colors.grey.darken4,
  teal: '#0BC19C',
  'viridian-green': '#25938F',
  accent: '#82B1FF',
  info: '#2196F3',
  success: '#4CAF50',
  brightSuccess: '#25CD2B',
  warning: '#FFEA47',
  secondary: colors.grey.darken1,
  background: '#f7f7f8',
  'blue-magenta': '#CEC8E6'
}

const starmindFontSet: IconSet = {
  component: (props) => {
    return h(
      'i',
      {
        class: (props.icon as string)?.startsWith('mdi') ? `mdi ${props.icon}` : props.icon,
        style: {
          fontSize: 'inherit'
        }
      }
    )
  }
}

export default function getVuetifyOpts() {
  return {
    components,
    directives,
    theme: {
      defaultTheme: 'light',
      options: { customProperties: true },
      themes: {
        light: {
          dark: false,
          colors: {
            ...defaultColors
          },
          variables: {
            'hover-opacity': 0.07,
            'text-field-outlined-border': 'rgba(0, 0, 0, 0.24)',
            'text-field-outlined-hover-border': 'rgba(16, 7, 7, 0.38)'
          }
        },
        dark: {
          dark: true,
          colors: {
            ...defaultColors,
            primary: '#0085CA',
            error: '#F93943',
            'sm-bronze': '#cc982d',
            purple: '#9e52bf',
            'indigo-darken3': '#283593',
            'pink-darken3': '#ad1457',
            teal: '#009688',
            'viridian-green': '#0085CA',
            'light-green-lighten5': '#f6faf3',
            warning: '#FFC107',
            info: '#2196F3'
          },
          variables: {
            'hover-opacity': 0.07,
            'text-field-outlined-border': 'rgba(0, 0, 0, 0.24)',
            'text-field-outlined-hover-border': 'rgba(16, 7, 7, 0.38)'
          }
        }
      }
    },
    icons: {
      defaultSet: 'starmindFontSet',
      aliases: {
        checkboxOff: 'ico-sm-checkbox-unchecked',
        checkboxOn: 'ico-sm-checkbox-checked',
        next: 'ico-sm-arrow-right',
        prev: 'ico-sm-arrow-left',
        radioOn: 'ico-sm-radiobutton-checked',
        radioOff: 'ico-sm-radiobutton-unchecked'
      },
      sets: { starmindFontSet }
    },
    defaults: {
      VCard: {
        elevation: 0,
        rounded: 'lg',
        variant: 'flat'
      },
      VCardTitle: {
        class: 'd-flex'
      },
      VBtn: {
        variant: 'elevated',
        rounded: 'pill',
        style: {
          height: 40,
          'letter-spacing': 'normal'
        }
      },
      VSelectionControl: {
        color: 'primary'
      },
      VSelect: {
        color: 'primary'
      },
      VTooltip: {
        color: 'secondary',
        style: {
          'text-align': 'center',
          'font-weight': 'bold'
        }
      },
      VTabs: {
        style: {
          'letter-spacing': 'normal',
          'font-size': '.875rem'
        }
      },
      VTab: {
        style: {
          'letter-spacing': 'normal',
          'font-size': '14px',
          color: 'rgb(117, 117, 117)'
        }
      },
      VDialog: {
        elevation: 24,
        rounded: 'lg'
      },
      VField: {
        variant: 'underlined'
      },
      VTextarea: {
        color: 'primary'
      },
      VTextField: {
        color: 'primary'
      },
      VToolbar: {
        color: 'white'
      },
      VCheckbox: {
        color: 'primary'
      },
      VChip: {
        style: {
          borderColor: 'rgba(0, 0, 0, .12)',
          borderRadius: '8px'
        }
      },
      VRadioGroup: {
        color: 'primary'
      },
      VCombobox: {
        color: 'primary',
        density: 'compact'
      },
      VContainer: {
        class: 'pa-0'
      },
      VIcon: {
        size: 24,
        color: 'inherit'
      },
      global: {
        style: {
          fontFamily: 'Inter, sans-serif'
        }
      }
    },
    display: {
      thresholds: {
        xs: 0,
        sm: 720,
        md: 960,
        lg: 1064,
        xl: 1360
      }
    }
  }
}
